import React from "react";
import { Box } from "@mui/material";
import MuscleGroupButton from "../../../../components/MuscleGroupButton";

const MuscleGroupButtonGroup = ({ muscleGroups, filter, onClick }) => {
  // Helper function to safely get muscle group data
  const getMuscleGroupData = (m) => {
    if (typeof m.data === "function") {
      return m.data();
    }
    return m;
  };

  // Add render counter to debug infinite re-renders
  const renderCount = React.useRef(0);
  renderCount.current += 1;

  console.log(`🔴 MuscleGroupButtonGroup Render #${renderCount.current}`, {
    muscleGroupsLength: muscleGroups?.length,
    muscleGroupIds: muscleGroups?.map((m) => getMuscleGroupData(m).id),
    filter,
    onClickRef: onClick?.toString().substring(0, 50) + "...",
    timestamp: new Date().toISOString().split("T")[1],
  });
  return (
    <Box
      sx={{
        display: "flex",
        flexWrap: "wrap",
        gap: 1,
        alignItems: "center",
        mb: 2,
      }}
    >
      {muscleGroups &&
        muscleGroups.map((m) => {
          const data = getMuscleGroupData(m);
          return (
            <MuscleGroupButton
              onClick={(id) => {
                if (onClick) {
                  onClick(id);
                }
              }}
              key={data.id}
              title={data.name}
              id={data.id}
              filter={filter}
            />
          );
        })}
    </Box>
  );
};

export default MuscleGroupButtonGroup;
